import { useCallback, ReactNode } from 'react';
import {
  ListItemButton, ListItemText, ListItemAvatar, Avatar,
} from '@mui/material';
import { AB2, AB3, S1 } from '../../../../theme';

export interface INavigationItemProps {
  pathname?: string;
  isActive?: boolean;
  text: string;
  icon?: ReactNode;
  onClick: (nextPathname: string | undefined) => void;
}

interface IBuildSXParams {
  isActive: boolean;
}

const buildSX = ({ isActive }: IBuildSXParams) => ({
  '&.MuiListItemButton-root': {
    color: isActive ? AB3 : S1,
    marginLeft: '8px',
    marginTop: '8px',
    borderRadius: '16px 0 0 16px',
    fontSize: '16px',
    lineHeight: '22px',
    transition: 'background-color 200ms linear',
    paddingLeft: '16px',
    backgroundColor: isActive ? S1 : null,
    '&:hover': {
      backgroundColor: isActive ? S1 : AB2,
    },
  },
  '.MuiListItemAvatar-root': {
    marginRight: '8px',
    minWidth: 'unset',
    svg: {
      transition: 'background-color 200ms linear',
    },
  },
  '.MuiAvatar-root': {
    color: isActive ? AB3 : S1,
    background: 'transparent',
    width: '24px',
    height: '24px',
    transition: 'background-color 200ms linear',
    borderRadius: 0,
  },
  '.MuiTypography-root': {
    fontWeight: 700,
  },
});

const NavigationItem = (props: INavigationItemProps) => {
  const {
    pathname,
    isActive = false,
    text,
    icon,
    onClick,
  } = props;

  const handleClick = useCallback(() => {
    onClick(pathname);
  }, [pathname, onClick]);

  return (
    <ListItemButton onClick={handleClick} sx={buildSX({ isActive })}>
      {icon && (
        <ListItemAvatar>
          <Avatar>
            {icon}
          </Avatar>
        </ListItemAvatar>
      )}
      <ListItemText>
        {text}
      </ListItemText>
    </ListItemButton>
  );
};

export default NavigationItem;
